"use client";

import FAQsHeroSection from "@/components/faqs/hero-section";
import FAQSection from "@/components/shared/faq-section";
import ContactFormSection from "@/components/faqs/contact-form-section";
import CTABannerSection from "@/components/shared/cta-banner-section";

export default function FAQsPageView() {
  return (
    <main>
      <FAQsHeroSection />
      <FAQSection variant="tabbed" />
      <ContactFormSection />
      <CTABannerSection />
    </main>
  );
}
